import { render, staticRenderFns } from "./MpMenuGroup.vue?vue&type=template&id=f302af46"
import script from "./MpMenuGroup.vue?vue&type=script&lang=js"
export * from "./MpMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports